var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConference(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.598 392.598",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M321.422,76.897c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.849-10.925-10.925-10.925 s-10.925,4.848-10.925,10.925C310.562,72.049,315.41,76.897,321.422,76.897z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M352.129,144.905c0-2.78-1.552-5.43-4.008-6.659c-16.743-8.663-36.719-8.663-53.463,0 c-2.392,1.228-3.943,3.879-3.943,6.659v16.937h61.414V144.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M196.331,76.897c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925 s-10.925,4.848-10.925,10.925S190.319,76.897,196.331,76.897z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M227.103,144.905c0-2.78-1.551-5.43-4.008-6.659c-16.743-8.663-36.719-8.663-53.463,0 c-2.392,1.228-3.943,3.879-3.943,6.659v16.937h61.414V144.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M71.305,76.897c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925 c-6.077,0-10.925,4.848-10.925,10.925S65.293,76.897,71.305,76.897z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M102.012,144.905c0-2.78-1.552-5.43-4.008-6.659c-16.743-8.663-36.719-8.663-53.463,0 c-2.392,1.228-3.943,3.879-3.943,6.659v16.937h61.414V144.905z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.362,
    y: 183.564,
    style: {
      fill: "#FFFFFF"
    },
    width: 322.004,
    height: 131.232
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M321.422,98.683c18.036,0,32.711-14.675,32.711-32.711s-14.675-32.711-32.711-32.711 c-18.036,0-32.711,14.675-32.711,32.711S303.386,98.683,321.422,98.683z M321.422,55.111c6.012,0,10.925,4.848,10.925,10.925 c0,6.012-4.849,10.925-10.925,10.925s-10.925-4.848-10.925-10.925C310.562,59.96,315.41,55.111,321.422,55.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M196.331,98.683c18.036,0,32.711-14.675,32.711-32.711s-14.675-32.711-32.711-32.711 S163.62,47.935,163.62,65.972S178.295,98.683,196.331,98.683z M196.331,55.111c6.012,0,10.925,4.848,10.925,10.925 c0,6.012-4.848,10.925-10.925,10.925s-10.925-4.848-10.925-10.925C185.406,59.96,190.319,55.111,196.331,55.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M71.305,98.683c18.036,0,32.711-14.675,32.711-32.711S89.341,33.261,71.305,33.261 S38.594,48,38.594,66.036S53.204,98.683,71.305,98.683z M71.305,55.111c6.012,0,10.925,4.848,10.925,10.925 c0,6.012-4.848,10.925-10.925,10.925c-6.077,0-10.925-4.848-10.925-10.925C60.38,59.96,65.293,55.111,71.305,55.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M381.737,161.778h-7.822V144.84c0-11.055-6.012-21.01-15.774-26.053 c-23.014-11.895-50.489-11.83-73.503,0c-9.762,5.042-15.774,14.998-15.774,26.053v16.937h-20.04V144.84 c0-11.055-6.012-21.01-15.774-26.053c-23.014-11.895-50.489-11.83-73.503,0c-9.762,5.042-15.774,14.998-15.774,26.053v16.937 h-20.04V144.84c0-11.055-6.012-21.01-15.774-26.053c-23.014-11.895-50.489-11.83-73.503,0 c-9.762,5.042-15.774,14.998-15.774,26.053v16.937h-7.758C4.913,161.778,0,166.626,0,172.703c0,6.012,4.848,10.925,10.925,10.925 h2.521v142.093c0,6.012,4.848,10.925,10.925,10.925h22.303v11.766c0,6.012,4.848,10.925,10.925,10.925s10.925-4.848,10.925-10.925 v-11.766h255.547v11.766c0,6.012,4.848,10.925,10.925,10.925c6.012,0,10.925-4.848,10.925-10.925v-11.766h22.303 c6.012,0,10.925-4.848,10.925-10.925V183.564h2.521c6.012,0,10.925-4.848,10.925-10.925 C392.533,166.626,387.749,161.778,381.737,161.778z M290.651,144.905c0-2.78,1.552-5.43,3.943-6.659 c16.743-8.663,36.784-8.663,53.463,0c2.392,1.228,4.008,3.879,4.008,6.659v16.937h-61.414V144.905L290.651,144.905z  M165.56,144.905c0-2.78,1.552-5.43,3.943-6.659c16.743-8.663,36.784-8.663,53.463,0c2.392,1.228,4.008,3.879,4.008,6.659v16.937 H165.56L165.56,144.905L165.56,144.905z M40.533,144.905c0-2.78,1.552-5.43,3.943-6.659c16.743-8.663,36.784-8.663,53.463,0 c2.392,1.228,4.008,3.879,4.008,6.659v16.937H40.533V144.905z M357.301,314.861H35.362V183.564h322.004v131.297H357.301z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M57.147,205.414v11.055h31.289c6.012,0,10.925,4.848,10.925,10.925 c0,6.012-4.848,10.925-10.925,10.925H57.147v21.786h9.568c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925 h-9.568v11.119h278.368v-87.661H57.147z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConference);
export default __webpack_public_path__ + "static/media/conference.d0f109528ec74fc8d5d24b9f9606076a.svg";
export { ForwardRef as ReactComponent };